module.exports = __webpack_public_path__ + "assets/images/close-white.79e370eb63dd95575ceac4c4d543ce18.svg";